
export default class Collectable {

	constructor (run, type, value) {

		this.run = run;
		this.type = type;
		this.value = value;
	}

	collect () {

		switch (this.type) {
		case "exp": this.run.champion.gainExp(this.value); break;
		case "bottledexp": this.run.champion.gainExp(this.value); break;
		case "gold": this.run.champion.gainGold(this.value); break;
		case "card": this.run.addCard(this.value);/*this.run.cardChoiceWith([this.value]);*/ break;
		case "cardchoice": if (this.run.choosingCard) this.run.storeCardChoice(); else this.run.cardChoice(true, 3, false, this.value); break;
		case "cardbundle": this.run.cardBundle(); break;
		case "rarecard": this.run.cardChoiceWith(this.run.generateCardChoices(1, true), true); break;
		case "health": this.run.champion.heal(this.value); break;
		case "insight": this.run.addInsight(this.value); break;
		case "paws": this.run.addPaws(1); break;
		case "relic": this.run.champion.newRelic(this.value); break;
		case "potion": this.run.champion.newPotion(this.value); break;
		case "berry": this.run.champion.heal(this.run.berryHp); break;
		case "coin": this.run.champion.gainGold(this.run.coinGold); break;
		case "remove": this.run.dropChoice(); break;
		case "seed": this.run.champion.gainExp(this.run.seedExp); break;
		case "key": this.run.getKey(); break;
		case "smallkey": this.run.addKeys(1); break;
		case "power": this.run.getPower(); break;
		case "escape": this.run.victory(); break;
		}
		this.run.notify("collect", this);
	}

	serialize () {

		return {
			type: this.type,
			value: this.value
		}
	}

	static build (run, src) {

		let collectable = new Collectable(run, src.type, src.value);
		return collectable;
	}
}
